import script from "./hct-message.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-message.vue?vue&type=script&setup=true&lang=js"

import "./hct-message.vue?vue&type=style&index=0&id=6b93348c&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b93348c"]])

export default __exports__